import { HttpClient } from '@angular/common/http';
import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { forkJoin } from 'rxjs'; 
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject, Injectable } from '@angular/core';
import { FunctionService , ThemeService } from 'vhobjects-service/src/services';
import { ColorContrastComponent } from '../../../../../color-contrast/color-contrast.component';

@Component({
  selector: 'atw-button-view-detail-config',
  templateUrl: './button-view-detail-config.component.html',
  styleUrls: ['./button-view-detail-config.component.scss'],
})
export class AtwButtonViewDetailConfig implements OnInit {
  isCollapsed: boolean = false;
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() device: any; // xác định device là desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any;@Input() type: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  currentViewAll: any = {}; // biến xác định mở rộng tất cả hay theo thuộc tính
  dataAfterChange: any = {}; // lưu tên và style data để cập nhật vào database.
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  id_subproject: any;
  arr_link_page: any;
  valueRange: number = 0; // biến này tính giá trị của (input range / 100) để tính độ trong suốt
  valueParameter: number = 0; // biến này tính giá trị của (input range) để hiện thị giá trị ra màn hình
  style_color: string = '' // biến này lấy giá trị của màu rgb và alpha;
  isOpenOptionsBorder: boolean = false;
  fonts = []

  backgroundColor: any = [];
  typeGradient = [
    {
      type: 'linear-gradient',
      direction: '',
      name: 'Mặc định',
      img: '/assets/root/images/system/imgs/gdDefault.png',
      deg: '180deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to right,',
      name: 'Từ trái sang phải',
      img: '/assets/root/images/system/imgs/gdToRight.png',
      deg: '90deg',
    },
    {
      type: 'linear-gradient',
      direction: 'to left,',
      name: 'Từ phải sang trái',
      img: '/assets/root/images/system/imgs/gdToLeft.png',
      deg: '270deg',
    },
  ];
  dataBorder = [
    {
      name: 'solid',
      img_border: 'https://static.thenounproject.com/png/2264019-200.png',
    },
    {
      name: 'dashed',
      img_border: 'https://static.thenounproject.com/png/2264023-200.png',
    },
    {
      name: 'dotted',
      img_border: 'https://static.thenounproject.com/png/2449182-200.png',
    },
  ];
  styles_field = [
    {
      title: 'dieu_chinh_noi_dung',
      index: 1,
    },
    {
      title: 'Điều chỉnh viền nút bấm',
      index: 2,
    },
    {
      title: 'hieu_ung_chuyen_dong',
      index: 3,
    },
    {
      title: 'nang_cao',
      index: 4,
    },
  ];
  effect_hover = [];
  effect_hover_data: any = {}
  width = 0;
  height = 0;

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private dialog: MatDialog,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    @Inject(PLATFORM_ID) private platformId: Object,
    public functionService:FunctionService,
    private matDialog: MatDialog,
    public themeService: ThemeService,
  ) { }
  parserPercent = (value: string): string => value.replace('%', '');
  formatterPercent = (value: number): string => {
    return `${value} %`;
  };

  ngOnInit(): void {
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/button.json'),
      this.http.get('assets/background-colors/background-colors.json'),
      this.http.get('assets/fonts/fonts.json')
    ]).subscribe(([effects, background_colors, fonts]: any) => {
      this.fonts = fonts;
      this.effect_hover = effects;
      this.backgroundColor = background_colors;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
    })
  }

  ngOnChanges({ device }: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId)){
      if (!this.staticdata.accessibility) this.staticdata.accessibility = {}; 
      
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;}
  }

  // hàm cập nhật background linear-gradient
  updateBackgroundRgb() {
    if (this.config['background-color'].gradient_check) {
      this.class['button']['background-image'] = "linear-gradient(" + this.config['background-color']['gradient_arr'] + ")";
    }
    else {
      this.class['button']['background-image'] = "none";
    }
    this.updateObject();
  }
  /**
   * Hàm update object vào database.
   */
  updateObject() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {
        
      })
  }
  /**
   *Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })
  }

  /**
   * hàm này để update width height trong dimention của config  
   */
  updateDimension(){
    if (isPlatformBrowser(this.platformId)){
    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.objectChoosing[this.device + '_config'] = {
      ...this.objectChoosing[this.device + '_config'],
      dimension: {
        width: Number(Number(this.width).toFixed(2)),
        height: Number(Number(this.height).toFixed(2))
      }
    }
    this.updateConfig()}
  }
  /**
  *Hàm update class vào database, và gửi cập nhật width, height cho object-selected
  */
  updateClassAndWidthHeight() {
    if (isPlatformBrowser(this.platformId)){
    this.width = document.getElementById(this.objectChoosing._id).clientWidth;
    this.height = document.getElementById(this.objectChoosing._id).clientHeight;
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {
        
      })}
  }

  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {
        
      })
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
        
      });
  }
  /**
   * remove link khi click vào nút x
   */
  removeLink() {
    this.staticdata.hyper_link = '';
    this.updateStaticData();
  }
  /**
   * Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');
    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /**Xử lý lấy thông số giá trị background color.
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundColor(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    // Tính giá trị alpha cho màu rgb.
    const data = this.class['button']
    // Nối chuỗi màu + độ mờ (alpha) và lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(data.background)}, ${this.config['background-color']['value_range'] / 100
      })`;
    data.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    // lấy giá trị tham số event của thanh slide khi thay đổi.
    this.valueParameter = e.target.value;
    if (this.device == 'desktop') {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] =
        this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      // Tách các phần tử màu từ chuỗi rgba.
      const newArr =
        this.config['background-color'].gradient_arr.map(
          (color) => {
            const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
          }
        );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateBackgroundRgb()
    } else {
      // Tính giá trị alpha cho màu rgb.
      this.config['background-color']['value_parameter'] =
        this.valueParameter;
      this.config['background-color']['value_range'] =
        this.valueParameter / 100;
      const newArr =
        this.config['background-color'].gradient_arr.map(
          (color) => {
            // Tách các phần tử màu từ chuỗi rgba
            const parts = color.match(/(\d+(\.\d+)?)/g);
            return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-color']['value_range']})`;
          }
        );
      // return giá trị chuỗi màu gradient và lưu vào database.
      this.config['background-color'].gradient_arr = newArr;
      this.updateClass()
    }
  }
  /** Hàm này lấy giá trị màu nền của input color
  * @param event : trả về màu được chọn từ input color
  */
  updateColorInput(e) {
    const value_color = e.target.value;
    const data_desktop = this.class['button'];
    const data_mobile = this.class['button'];
    // Chuyển đổi chuổi màu hexadecimal thành rgb
    // Nối chuỗi rgb + giá trị alpha và cập nhật lưu vào database.
    this.style_color = `rgba(${this.hexToRGB(value_color)}, ${this.config['background-color']['value_range']
      })`;
    data_desktop.background_rgb = this.style_color;
    this.updateClass();
  }
  /**Hàm này dùng để click chọn màu nền của danh sách màu.
   * @param bgColor : trả về màu được chọn
   * @param event : trả về element được active
   */
  chooseBg(bgColor, event) {
    if (isPlatformBrowser(this.platformId)){

    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    // Lấy ra element màu được click từ tham số event trả về.
    var activeGradient = document.querySelector(
      '.container-color .active'
    ) as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    // Lấy giá trị màu được click từ tham số bgColor.
    //  Chuyển đổi màu được click thành mã rgb , thêm alpha vào mã rgb và lưu vào database.
    const data_background = this.class['button']
    data_background['background-color'] = bgColor.bgColor;
    data_background['background-color'] = `rgba(${this.hexToRGB(data_background['background-color'])}, ${this.config['background-color'].value_range})`;
    this.updateObject();}
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    if (isPlatformBrowser(this.platformId)){
    // Get class active của element khi click chọn hướng phối màu.
    // Set style hightlight cho element có class active để biết options direction nào đang được chọn.
    var activeGradient = document.querySelector('.active') as HTMLElement;
    if (activeGradient) activeGradient.classList.remove('active');
    event.currentTarget.classList.add('active');
    // Gán các properties của phần tử direction vào biến trong json và cập nhật lưu vào database.
    this.config['background-color'].gradient_type = direction.type;
    this.config['background-color'].gradient_direction = direction.direction;
    this.class['button']['background'] = this.config['background-color'].gradient_type + '(' + this.config['background-color'].gradient_direction + this.config['background-color'].gradient_arr.join(',') + ')'
    this.updateConfig();
    this.updateClass();}
  }

  customize = []
  /** Xử lý border
  */
  toggleBorder(isActive) {
    const active = this.class['button'];
    active.check_border = isActive;
    active.check_border_top = isActive;
    active.check_border_bottom = isActive;
    active.check_border_right = isActive;
    active.check_border_left = isActive;
    this.updateClass();
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId))
    document.getElementById('input-gradient').click();
  }

  /**
   * Hàm này thực hiện thêm màu gradient vào array.
   *
   */
  addGradient(value) {
    if (/\#/.test(value)) {
      const gradient =
        this.device == 'desktop'
          ? this.config['background-color']
          : this.config['background-color'];
      gradient[`gradient_arr`].push(
        `rgba(${this.hexToRGB(value)}, ${gradient.value_range})`
      );
      this.updateBackgroundRgb();
    }
  }
  /**
   * @param index : vị trí phần tử muốn xóa
   * Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
   */
  deleteGradient(index) {
    if (this.config['background-color'][`gradient_arr`].length > 1) {
      this.config['background-color'][`gradient_arr`].splice(index, 1);
      this.updateBackgroundRgb()
    }
  }
  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }


  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openMap: { [name: string]: boolean } = {
    menu1: true, menu2: false, menu3: false, menu4: false, menu5: false, menu6: false, menu7: false, menu8: false
  };

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    //Vì thay đổi kích thước width, height của button chính là thay đổi giá trị padding, còn các giá trị khác như kích thước nội dung chữ, kích thước border... ko thay đôi,
    //do đó ta chỉ tính lại giá trị padding mới theo khoảng giá trị thay đổi của width, height
    if (event.width) {
      this.class['button']['padding-left'] = Number(this.class['button']['padding-left'].toString().match(/\d+(\.\d+)?/g).join("")) + (event.width - this.width) / 2 + 'px';
      this.class['button']['padding-right'] = Number(this.class['button']['padding-right'].toString().match(/\d+(\.\d+)?/g).join("")) + (event.width - this.width) / 2 + 'px';
    }
    if (event.height) {
      this.class['button']['padding-top'] = Number(this.class['button']['padding-top'].toString().match(/\d+(\.\d+)?/g).join("")) + (event.height - this.height) / 2 + 'px';
      this.class['button']['padding-bottom'] = Number(this.class['button']['padding-bottom'].toString().match(/\d+(\.\d+)?/g).join("")) + (event.height - this.height) / 2 + 'px';
    }
    this.updateClassAndWidthHeight();
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.styles_field[2])
  }

  /**
   * Mở popup so sánh màu nền và màu chữ có tương phản hay không
   * (Để tối ưu Accessibility trong SEO)
   */
  openColorContrast() {
    const colorClass = this.class.button__content.color ? 'button__content' : 'button';
    const dialogRef = this.matDialog.open(ColorContrastComponent, {
      width: '30vw',
      height: 'fit-content',
      data: {
        /** Chứa map màu nền và màu chữ/icon */
        colorContrast: {
          typeFgColor: 'text',
          textOrIconColor: this.class[colorClass].color,
          bgColor: this.class.button['background-color'],
        }
      },
    });

    dialogRef.afterClosed().subscribe((colorContrast) => {
      if (colorContrast) {
        this.class[colorClass].color = colorContrast.textOrIconColor;
        this.class.button['background-color'] = colorContrast.bgColor;
        this.updateClass();
      }
    });
  }
}
